import React, { Component } from "react";
import { FormattedMessage, injectIntl } from 'react-intl'

import downloadQrcode from "./res/pdv2/phone-down.png"
import upgradeVip from "./res/phonedownload/upgrade_vip.png"
import getApple from "./res/pdv2/get-apple.png"
import getGoogle from "./res/pdv2/get-google.png"
import rollImage from "./res/pdv2/roll.png"
import btnIcoIos from "./res/pdv2/btn-ico-ios.png"
import btnIcoAndroid from "./res/pdv2/btn-ico-android.png"
import btnIcoHmos from "./res/pdv2/btn-ico-hmos.png"
import btnBg from "./res/pdv2/btn-bg.png"
import btnBgHover from "./res/pdv2/btn-bg-hover.png"
import btnBgClick from "./res/pdv2/btn-bg-click.png"
import coverLeft from "./res/pdv2/cover-left.png"
import coverLeftHover from "./res/pdv2/cover-left-hover.png"
import coverLeftClick from "./res/pdv2/cover-left-click.png"
import coverRight from "./res/pdv2/cover-right.png"
import coverRightHover from "./res/pdv2/cover-right-hover.png"
import coverRightClick from "./res/pdv2/cover-right-click.png"
import Locale from './lang/Locale'

import { message } from 'antd';

import "./PhoneDownloadV2.css";
import "antd/dist/antd.min.css";
import "url-search-params-polyfill"


const androidAddress = 'https://play.google.com/store/apps/details?id=com.xdiarys.www'
const androidChsAddress = 'https://download.xdiarys.com/android/dkcalendar-release.apk'
const homepage = 'https://www.xdiarys.com/?src=windows';

const errorMessage = ( msg ) => {
    message.error( msg );
};

const successMessage = ( msg ) => {
    message.success( msg, 10 );
};

class PhoneDownloadV2 extends Component {

    constructor(props) {

        super(props);

        
        const { intl } = this.props;

        this.state = {
            vipdisplay:'none',
            othersysText:intl.formatMessage({ id: 'phodedownload_macos' }),
            systemimage: require("./res/phonedownload/appstore.png"),
            ioslink:'',
            otherlink:'',
            taskKey:'',
            currentSlide: 0,
            isTransitioning: false,
            transitionDirection: '',
            autoPlay: true,
            autoPlayInterval: null,
            showQRCode: false,
            qrCodeType: '', // 'ios' or 'android'
            qrPosition: { left: 0, top: 0 } // 二维码显示位置
        };

        this.onclickDownloadiOS = this.onclickDownloadiOS.bind(this);
        this.nextSlide = this.nextSlide.bind(this);
        this.prevSlide = this.prevSlide.bind(this);
        this.goToSlide = this.goToSlide.bind(this);
        this.startAutoPlay = this.startAutoPlay.bind(this);
        this.stopAutoPlay = this.stopAutoPlay.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handleIOSButtonClick = this.handleIOSButtonClick.bind(this);
        this.handleAndroidButtonClick = this.handleAndroidButtonClick.bind(this);
        this.handleHarmonyOSButtonClick = this.handleHarmonyOSButtonClick.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

    }

    componentWillMount() {
        const { intl } = this.props;

        var search = new URLSearchParams(window.location.search);
        let paramOS = search.get("os");
        let taskKey = search.get("task_key");

        let lang = Locale.Instance.getLang();
        

        let country = 'us';
        if( lang === 'chs' ) {
            country = 'cn';
        } else if( lang === 'cht' ) {
            country = 'tw';
        } else if( lang === 'kor' ) {
            country = 'kr';
        }

        let macOSUrl = `https://apps.apple.com/${country}/app/CalendarTask/id1570563588`;
        let iOSUrl = `https://apps.apple.com/${country}/app/CalendarTask/id1570563588?platform=iphone`;


        
        document.title = Locale.Instance.getMessagebyId('homepage_title');

        this.setState( { ioslink:iOSUrl, otherlink:macOSUrl });

        this.setState( { taskKey:taskKey });

        
        if( paramOS === 'macos') {
            let text = intl.formatMessage({ id: 'phodedownload_windows' });
            let image = require("./res/phonedownload/windows.png");
            let link = homepage;
            this.setState( {othersysText:text, systemimage:image, otherlink:link});
        }

        let paramVip = search.get("vip");
        if( paramVip === '1' ) {
            this.setState( {vipdisplay:'block'});
        }

        console.log(taskKey)
        if (taskKey != null && taskKey.length > 0) {
            this.AcceptTask(taskKey);
        }
    }

    async AcceptTask(taskKey) {
        
        let retobj = await fetch( 'https://api-account.xdiarys.com/api/users/task/accept/' + taskKey, {
            method: "GET",
            credentials: 'include',
            headers: {
            'Accept': 'application/json, text/plain, */*',
            }
        })
        .then(function (response) {
            return  response.json();
        })
        .then((myJson) => {
            return myJson;
        })
        .catch(function (e) {
            console.log( e );
        });

        
        console.log( retobj );
        if( retobj.result === 1 ) {
            successMessage(Locale.Instance.getMessagebyId('vip_task_succ'));
        } else{
            errorMessage(Locale.Instance.getMessagebyId('vip_task_error'));
        }
    }
    
    componentDidMount() {
       
        this.onclickDownloadAndrod = this.onclickDownloadAndrod.bind(this);
        this.startAutoPlay();
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        this.stopAutoPlay();
        document.removeEventListener('click', this.handleClickOutside);
    }

    onclickDownloadAndrod(){
        let lang = Locale.Instance.getLang();
        if( lang === 'chs' ) {
            window.location.href = androidChsAddress;
        } else {
            window.location.href = androidAddress;
        }
    }

    onclickDownloadiOS(){
        window.location.href = this.state.ioslink;
    }

    // 自动播放相关方法
    startAutoPlay() {
        if (this.state.autoPlayInterval) {
            clearInterval(this.state.autoPlayInterval);
        }
        
        const interval = setInterval(() => {
            if (!this.state.isTransitioning) {
                this.nextSlide();
            }
        }, 3000); // 每3秒自动切换
        
        this.setState({ autoPlayInterval: interval });
    }

    stopAutoPlay() {
        if (this.state.autoPlayInterval) {
            clearInterval(this.state.autoPlayInterval);
            this.setState({ autoPlayInterval: null });
        }
    }

    handleMouseEnter() {
        this.stopAutoPlay();
    }

    handleMouseLeave() {
        if (this.state.autoPlay) {
            this.startAutoPlay();
        }
    }

    // 按钮点击事件处理
    handleIOSButtonClick(event) {
        const buttonRect = event.currentTarget.getBoundingClientRect();
        const containerRect = event.currentTarget.closest('.download-section').getBoundingClientRect();
        
        this.setState({
            showQRCode: !this.state.showQRCode || this.state.qrCodeType !== 'ios',
            qrCodeType: 'ios',
            qrPosition: {
                left: buttonRect.left - containerRect.left + (buttonRect.width / 2) - 110, // 110是二维码宽度的一半
                top: buttonRect.bottom - containerRect.top + 16
            }
        });
    }

    handleAndroidButtonClick(event) {
        const buttonRect = event.currentTarget.getBoundingClientRect();
        const containerRect = event.currentTarget.closest('.download-section').getBoundingClientRect();
        
        this.setState({
            showQRCode: !this.state.showQRCode || this.state.qrCodeType !== 'android',
            qrCodeType: 'android',
            qrPosition: {
                left: buttonRect.left - containerRect.left + (buttonRect.width / 2) - 110, // 110是二维码宽度的一半
                top: buttonRect.bottom - containerRect.top + 16
            }
        });
    }

    // HarmonyOS按钮点击事件处理
    handleHarmonyOSButtonClick() {
        message.info('请在应用商店 搜索【日历清单】下载', 5);
    }

    // 点击外部区域关闭二维码
    handleClickOutside(event) {
        if (this.state.showQRCode) {
            const downloadSection = event.target.closest('.download-section');
            if (!downloadSection) {
                this.setState({
                    showQRCode: false,
                    qrCodeType: ''
                });
            }
        }
    }

    // 轮播图方法
    nextSlide() {
        if (this.state.isTransitioning) return;
        const { currentSlide } = this.state;
        const totalSlides = 7; // 总共7张图片
        const newSlide = (currentSlide + 1) % totalSlides;
        
        this.setState({
            isTransitioning: true,
            transitionDirection: 'slide-right'
        });
        
        // 短暂延迟后切换图片，确保动画开始
        setTimeout(() => {
            this.setState({ currentSlide: newSlide });
        }, 50);
        
        // 动画完成后重置状态
        setTimeout(() => {
            this.setState({ 
                isTransitioning: false,
                transitionDirection: ''
            });
        }, 500);
    }

    prevSlide() {
        if (this.state.isTransitioning) return;
        const { currentSlide } = this.state;
        const totalSlides = 7; // 总共7张图片
        const newSlide = currentSlide === 0 ? totalSlides - 1 : currentSlide - 1;
        
        this.setState({
            isTransitioning: true,
            transitionDirection: 'slide-left'
        });
        
        // 短暂延迟后切换图片，确保动画开始
        setTimeout(() => {
            this.setState({ currentSlide: newSlide });
        }, 50);
        
        // 动画完成后重置状态
        setTimeout(() => {
            this.setState({ 
                isTransitioning: false,
                transitionDirection: ''
            });
        }, 500);
    }

    goToSlide(index) {
        if (this.state.isTransitioning || index === this.state.currentSlide) return;
        const { currentSlide } = this.state;
        const direction = index > currentSlide ? 'slide-right' : 'slide-left';
        
        this.setState({
            isTransitioning: true,
            transitionDirection: direction
        });
        
        // 短暂延迟后切换图片，确保动画开始
        setTimeout(() => {
            this.setState({ currentSlide: index });
        }, 50);
        
        // 动画完成后重置状态
        setTimeout(() => {
            this.setState({ 
                isTransitioning: false,
                transitionDirection: ''
            });
        }, 500);
    }

    render() { 
        let lang = Locale.Instance.getLang();
        let resLang = Locale.Instance.getResourceLang();
        var logo = require("./res/pdv2/logo-" + resLang + ".png");
        var phoneImage = require("./res/pdv2/phone-" + resLang + ".png");
        
        return (
            <div className="pay-v2-html" >

                
                <div className="pay-v2-body" >

                    <div className="bi-v2-top" >
                        <div className="bi-v2-top-contain" >

                            <div className="w45 float-left aling-left logo-area" >
                                <img className="logo" src={logo} /> 
                            </div>
                            <div className="v2-more-area float-right" >
                            </div>
                        </div>
                    </div>

                    <div className="pay-v2-body-contain" >
                        {/* 左侧内容区域 */}
                        <div className="left-content">
                            {/* 标题描述下载按钮组合区域 */}
                            <div className="title-description-download-wrapper">
                                {/* 1. 标题 */}
                                <div className="content-section title-section">
                                    <div className="main-title">
                                        <span className="title-part1">{Locale.Instance.getMessagebyId('v2_main_title_part1')}</span>
                                        <span className="title-part2">{Locale.Instance.getMessagebyId('v2_main_title_part2')}</span>
                                    </div>
                                </div>

                                {/* 2. 描述 */}
                                <div className="content-section description-section">
                                    <span className="main-description" dangerouslySetInnerHTML={{__html: Locale.Instance.getMessagebyId('v2_main_description')}}></span>
                                </div>

                                {/* 3. 下载按钮 */}
                                <div className="content-section download-section">
                                    <div className="main-download-buttons">
                                        <button  className="download-btn ios" onClick={this.handleIOSButtonClick}>
                                            <div className="btn-icon">
                                                <img src={btnIcoIos} alt="iOS" width="24" height="24" />
                                            </div>
                                            <span>{Locale.Instance.getMessagebyId('v2_download_ios')}</span>
                                        </button>
                                        <button className="download-btn android" onClick={this.handleAndroidButtonClick}>
                                            <div className="btn-icon">
                                                <img src={btnIcoAndroid} alt="Android" width="24" height="24" />
                                            </div>
                                            <span>{Locale.Instance.getMessagebyId('v2_download_android')}</span>
                                        </button>
                                        {lang !== 'chs' ? null : (
                                        <button className="download-btn harmonyos" onClick={this.handleHarmonyOSButtonClick}>
                                            <div className="btn-icon">
                                                <img src={btnIcoHmos} alt="HarmonyOS" width="24" height="24" />
                                            </div>
                                            <span>{Locale.Instance.getMessagebyId('v2_download_harmonyos')}</span>
                                        </button>
                                        )}
                                    </div>
                                    
                                    {/* 二维码显示区域 */}
                                    {this.state.showQRCode && (
                                        <div 
                                            className="qr-code-container"
                                            style={{
                                                left: `${this.state.qrPosition.left}px`,
                                                top: `${this.state.qrPosition.top}px`
                                            }}
                                        >
                                            <img 
                                                src={downloadQrcode} 
                                                className="qr-code-image"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* 4. 轮播图片 */}
                            <div className="content-section carousel-section">
                                <div 
                                    className="carousel-container"
                                    onMouseEnter={this.handleMouseEnter}
                                    onMouseLeave={this.handleMouseLeave}
                                >
                                    <div className="carousel-wrapper">
                                        <button 
                                            className="carousel-btn carousel-btn-prev" 
                                            onClick={this.prevSlide}
                                            disabled={this.state.isTransitioning}
                                        >
                                            <img 
                                                src={coverLeft} 
                                                className="carousel-btn-img carousel-btn-img-prev"
                                                onMouseOver={(e) => e.target.src = coverLeftHover}
                                                onMouseOut={(e) => e.target.src = coverLeft}
                                                onMouseDown={(e) => e.target.src = coverLeftClick}
                                                onMouseUp={(e) => e.target.src = coverLeftHover}
                                            />
                                        </button>
                                        <div className="carousel-slides">
                                            <img 
                                                src={require("./res/pdv2/cover/" + String(this.state.currentSlide + 1).padStart(2, '0') + "-" + resLang + ".png")} 
                                                className={`carousel-image ${this.state.isTransitioning ? this.state.transitionDirection : ''}`}
                                            />
                                        </div>
                                        <button 
                                            className="carousel-btn carousel-btn-next" 
                                            onClick={this.nextSlide}
                                            disabled={this.state.isTransitioning}
                                        >
                                            <img 
                                                src={coverRight} 
                                                className="carousel-btn-img carousel-btn-img-next"
                                                onMouseOver={(e) => e.target.src = coverRightHover}
                                                onMouseOut={(e) => e.target.src = coverRight}
                                                onMouseDown={(e) => e.target.src = coverRightClick}
                                                onMouseUp={(e) => e.target.src = coverRightHover}
                                            />
                                        </button>
                                    </div>
                                    <div className="carousel-indicators">
                                        {[0, 1, 2, 3, 4, 5, 6].map((index) => (
                                            <button
                                                key={index}
                                                className={`carousel-indicator ${this.state.currentSlide === index ? 'active' : ''}`}
                                                onClick={() => this.goToSlide(index)}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 右侧图片区域 */}
                        <div className="right-content">
                            <img src={phoneImage} className="phone-image" />
                        </div>
                    </div>
                </div>


                <div className='styleV2-footer'>
                    <div className="footer-container">
                        <div className="download-buttons">
                            <a href={this.state.ioslink} className="download-button app-store" target="_blank" rel="noopener noreferrer">
                                <img src={getApple} alt="Download on the App Store" className="download-button-img" />
                            </a>
                            {lang === 'chs' ? null : (
                            <a href={androidAddress} className="download-button google-play" target="_blank" rel="noopener noreferrer">
                                <img src={getGoogle} alt="GET IT ON Google Play" className="download-button-img" />
                            </a>
                            )}
                        </div>
                        <div className="footer-info">
                            <div className="footer-text" dangerouslySetInnerHTML={{__html: Locale.Instance.getMessagebyId('v2_copyright')}}></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



export default injectIntl(PhoneDownloadV2);